export default {
  title: "快捷鍵說明",
  userHelp: "使用者幫助",
  canvasOperationTip: {
    title: "畫布操作提示",
    tooltip: "畫布操作節點時的步驟提示",
  },
  reopenUserGuide: "再看一遍使用者引導",
  shortcuts: {
    selectAll: {
      label: "全選",
      key: "ctrl+A/⌘+A",
    },
    multiSelect: {
      label: "多選",
      key: "ctrl/⌘+滑鼠左鍵選擇多個節點",
    },
    boxSelect: {
      label: "多選框選",
      key: "滑鼠右鍵框選多個節點",
    },
    previousStep: {
      label: "上一步",
      key: "ctrl+Z/⌘+Z",
    },
    nextStep: {
      label: "下一步",
      key: "ctrl+F/⌘+F",
    },
    expandDetails: {
      label: "展開詳情",
      description: "（節點/交易邊詳情）",
      key: "ctrl+E/⌘+E",
    },
    saveCanvas: {
      label: "儲存畫布",
      key: "alt+S/⌥+S",
    },
    nodeRemark: {
      label: "節點備註",
      description: "（選中至少一個節點）",
      key: "alt+V/⌥+V",
    },
    copyAddress: {
      label: "複製地址",
      description: "（選中至少一個節點）",
      key: "ctrl+C/⌘+C",
    },
    deleteNode: {
      label: "刪除節點",
      description: "（選中至少一個節點）",
      key: "Delete",
    },
    newCanvas: {
      label: "新建畫布",
      description: "（選中至少一個節點）",
      key: "alt+G/⌥+G",
    },
    addMonitor: {
      label: "加入監控",
      description: "（選中一個節點）",
      key: "ctrl+M/⌘+M",
    },
    directAssociation: {
      label: "直接關聯",
      description: "（選中多個節點）",
      key: "ctrl+R/⌘+R",
    },
    batchExpand: {
      label: "批量擴展",
      description: "（選中多個節點）",
      key: "enter/return",
    },
  },
};
